import { Heading, Subheading } from './heading'
import { Select } from './select'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './table'
import { CircleStackIcon } from '@heroicons/react/16/solid';
import { Divider } from './divider'
import { Badge } from './badge'
import { useNavigate } from 'react-router-dom'

export function DashboardContent() {
  const navigate = useNavigate();
  const GotoPage = (pageName) => {
		navigate(`${pageName}`);
	};
    return (
    <>
      <div className="flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
      <CircleStackIcon className="!size-8" />
      <Heading>Your Dashboard</Heading>
      </div>
      <div className="mt-8 flex items-end justify-between">
        <Subheading>Overview</Subheading>
      </div>
      <div className="mt-4 grid gap-8 sm:grid-cols-2 xl:grid-cols-4">
        <div className='rounded-lg'>
              <Divider />
              <div className="mt-4 text-lg/6 font-medium sm:text-sm/6 dark:text-white">Total Accounts</div>
              <div className="mt-3 text-3xl/8 font-semibold sm:text-2xl/8 dark:text-white">45</div>
              <div className="mt-3 text-sm/6 sm:text-xs/6">
                <Badge color='lime'>+4</Badge>{' '}
                <span className="text-zinc-500">from last week</span>
              </div>
        </div>
        <div className='rounded-lg'>
              <Divider />
              <div className="mt-4 text-lg/6 font-medium sm:text-sm/6 dark:text-white">Tests Running</div>
              <div className="mt-3 text-3xl/8 font-semibold sm:text-2xl/8 dark:text-white">54</div>
        </div>
        <div className='rounded-lg'>
              <Divider />
              <div className="mt-4 text-lg/6 font-medium sm:text-sm/6 dark:text-white">Average Uplift Found</div>
              <div className="mt-3 text-3xl/8 font-semibold sm:text-2xl/8 dark:text-white">23%</div>
        </div>
        <div className='rounded-lg'>
              <Divider />
              <div className="mt-4 text-lg/6 font-medium sm:text-sm/6 dark:text-white">Tokens used (this month)</div>
              <div className="mt-3 text-3xl/8 font-semibold sm:text-2xl/8 dark:text-white">65,789</div>
        </div>
      </div>
      <Table grid className="mt-12 [--gutter:--spacing(6)] lg:[--gutter:--spacing(10)]">
        <TableHead>
          <TableRow>
            <TableHeader>Account Name</TableHeader>
            <TableHeader>Country</TableHeader>
            <TableHeader>Title tests</TableHeader>
            <TableHeader>Average uplift</TableHeader>
            <TableHeader>Tokens used</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
            <TableRow>
              <TableCell>Aspinal of London US</TableCell>
              <TableCell>US</TableCell>
              <TableCell>5</TableCell>
              <TableCell><Badge color='green'>17%</Badge></TableCell>
              <TableCell>11,456</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Hobbycraft GB</TableCell>
              <TableCell>UK</TableCell>
              <TableCell>8</TableCell>
              <TableCell><Badge color='green'>25%</Badge></TableCell>
              <TableCell>19,400</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Cookson GB</TableCell>
              <TableCell>UK</TableCell>
              <TableCell>3</TableCell>
              <TableCell><Badge color='green'>10%</Badge></TableCell>
              <TableCell>7,111</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Fred Perry FR</TableCell>
              <TableCell>FR</TableCell>
              <TableCell>6</TableCell>
              <TableCell><Badge color='green'>19%</Badge></TableCell>
              <TableCell>14,091</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Funky Pigeon GB</TableCell>
              <TableCell>UK</TableCell>
              <TableCell>2</TableCell>
              <TableCell><Badge color='green'>8%</Badge></TableCell>
              <TableCell>6,872</TableCell>
            </TableRow>
        </TableBody>
      </Table>
    </>
    );
}